import React from 'react';

import { useSelector } from 'react-redux';

import useElementBottomPosition, { SNACKBAR_POSITION } from 'hooks/useElementBottomPosition';
import { itinerariesItemDataSelector } from 'store/itinerariesItem/selectors';

import DetailsChronologicalMode from './DetailsChronologicalMode';
import DetailsOriginalMode from './DetailsOriginalMode';
import { EDetailsMode } from './types';

function Details() {
  useElementBottomPosition(SNACKBAR_POSITION);
  const itinerary = useSelector(itinerariesItemDataSelector);

  if (itinerary.detailsMode !== EDetailsMode.Chronological) {
    return <DetailsOriginalMode />;
  }

  return <DetailsChronologicalMode />;
}

export default Details;
